import { GradeThresholds } from './riskSetupDraft.types';

const EQUAL_WIDTHS = [20, 20, 20, 20, 20];

/**
 * Widths (percent) of the five grade-bar segments, Negligible → Extreme, each
 * proportional to its band within 0..gradeMax. Falls back to equal widths
 * when any band is NaN/negative (e.g. a cleared or out-of-order threshold) or
 * the scale is empty, so the bar never renders a negative or NaN width.
 */
export const gradeBarWidths = (
	{ low, medium, high, extreme }: GradeThresholds,
	gradeMax: number,
): number[] => {
	const edges = [0, low, medium, high, extreme, gradeMax];
	const spans = edges.slice(1).map((to, i) => to - edges[i]);
	const valid =
		gradeMax > 0 && spans.every(span => Number.isFinite(span) && span >= 0);
	if (!valid) return EQUAL_WIDTHS.slice();
	return spans.map(span => (span / gradeMax) * 100);
};
